export default __webpack_public_path__ + "static/media/LogoCelciusColor.a7b9ea3c.svg";